import './../../../resources/RTCC/css/reservation/reservation.css';

export const RecommendationPlanContainer = (props) => {
    const {
        recommendPlanList,
        handlePlanDetail
    } = props;

    return (

        <div className="RecommendationBlock">
            <h3>おすすめ情報</h3>
            <div className="RecommendationPlanList">
                {recommendPlanList ? recommendPlanList.map((plan, index) =>
                    <div key={"plan" + index} className="RecommendationPlan">
                        <img
                            src={plan.hotelImagePath}
                            style={{ width: "300px", height: "200px" }}
                            onError={e => e.target.parentElement.style.display = "none"}
                            onClick={() => handlePlanDetail(plan.hotelId, plan.planId)}
                            tabIndex="16"
                        />
                        <img
                            src={plan.roomImagePath}
                            style={{ display: "none" }}
                            onError={e => e.target.parentElement.style.display = "none"}
                        />
                        <div className="PlanDetailCaption">
                            <p className="PlanDetailHotel">{plan.hotelName}</p>
                            <p className="PlanDetailName">{plan.planName}</p>
                            {/* <p className="PlanDetailPrice">{"￥" + plan.planPrice}</p> */}
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

